import { SERVER_WEB_ROUTE_MATCHERS } from 'constants/routes';
import { IS_WL_QUERY_TRUE_STRING } from 'constants/wl';

const getPathname = (url: string): string => {
  try {
    return new URL(url).pathname;
  } catch {
    return url.split(/[?#]/)[0];
  }
};

export const checkIsWLByUrl = (url?: string): boolean => {
  if (!url) {
    return false;
  }

  if (url.includes(IS_WL_QUERY_TRUE_STRING)) {
    return true;
  }

  const pathname = getPathname(url);

  return SERVER_WEB_ROUTE_MATCHERS.userFormWl.some((matcher) => matcher.test(pathname));
};
